import axios from 'axios'
import * as actions from '../constants'

export const loadUser = (_id) => (dispatch, getState)=>{
  if(!getState().user.users[_id]){
    dispatch({
      type: actions.LOAD_USER_REQUEST,
      payload: _id
    })
  }
  axios.get(`/user/${_id}`).then(({data})=>{
    dispatch({
      type: actions.LOAD_USER_SUCCESS,
      payload: {
        user: data,
        _id
      }
    })
    dispatch(loadUserPosts(data._id))
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_USER_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const loadMy = () => dispatch=>{
  dispatch({
    type: actions.LOAD_MY_REQUEST
  })
  axios.get(`/user`).then(({data})=>{
    dispatch({
      type: actions.LOAD_MY_SUCCESS,
      payload: data
    })
    dispatch(loadMyLikes(data._id))
    dispatch(loadMyComments(data._id))
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_MY_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const togglePostForm = () => dispatch=> {
  dispatch({
    type: actions.TOGGLE_POST_FORM
  })
}

export const toggleCommentForm = () => dispatch=> {
  dispatch({
    type: actions.TOGGLE_COMMENT_FORM
  })
}

export const updatePostInput = (post) => dispatch=> {
  dispatch({
    type: actions.UPDATE_POST_INPUT,
    payload: post
  })
}

export const updateCommentInput = (comment) => dispatch=> {
  dispatch({
    type: actions.UPDATE_COMMENT_INPUT,
    payload: comment
  })
}

export const loadUserPosts = (id) => (dispatch, getState)=>{
  if(!getState().user.posts[id]) {
    dispatch({
      type: actions.LOAD_USER_POSTS_REQUEST,
      payload: {_id: id}
    })
  }
  axios.get(`/user/${id}/posts`).then(({data})=>{
    dispatch({
      type: actions.LOAD_USER_POSTS_SUCCESS,
      payload: {_id: id, posts:data}
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_USER_POSTS_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const loadMyComments = (id) => dispatch=>{
  dispatch({
    type: actions.LOAD_MY_COMMENTS_REQUEST
  })
  axios.get(`/user/${id}/comments`).then(({data})=>{
    dispatch({
      type: actions.LOAD_MY_COMMENTS_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_MY_COMMENTS_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const loadMyLikes = (id) => dispatch=>{
  dispatch({
    type: actions.LOAD_MY_LIKES_REQUEST,
    payload: {_id: id}
  })
  axios.get(`/user/${id}/likes`).then(({data})=>{
    dispatch({
      type: actions.LOAD_MY_LIKES_SUCCESS,
      payload: {_id: id, likes:data}
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_MY_LIKES_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const createCommentLike = (id) => dispatch=>{
  dispatch({
    type: actions.CREATE_COMMENT_LIKE_REQUEST
  })
  axios.post(`/comments/${id}/like`, {}).then(({data})=>{
    dispatch({
      type: actions.CREATE_COMMENT_LIKE_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.CREATE_COMMENT_LIKE_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const createPostLike = (id) => dispatch=>{
  dispatch({
    type: actions.CREATE_POST_LIKE_REQUEST
  })
  axios.post(`/posts/${id}/like`, {}).then(({data})=>{
    dispatch({
      type: actions.CREATE_POST_LIKE_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.CREATE_POST_LIKE_FAILURE,
      payload: (error.response && error.response.data) || error.message
    })
  })
}

export const activePost = (_id) => dispatch=>{
  dispatch({
    type: actions.ACTIVE_POST,
    payload: _id
  })
}

export const toggleIntro = () => dispatch=>{
  dispatch({
    type: actions.TOGGLE_INTRO
  })
}




// WEBPACK FOOTER //
// ./src/actions/user.js